export default "__VITE_ASSET__D7cgd5v3__"